// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"7671cf80","59":"7671cf80","105":"7671cf80","119":"7671cf80","777":"7671cf80","806":"7671cf80","971":"7671cf80"}[chunkId] + ".chunk.css";
};